
<myapp-image-asset style="width: 200px;" [imageAsset]="organization?.Logo" [width]="200" [height]="200" [usePlaceholder]="true" [useBorder]="false"></myapp-image-asset>

<myapp-breadcrumb class="breadcrumb-area" [folder]="folder"></myapp-breadcrumb>

<div class="loading" *ngIf="loading">
    <myapp-loading></myapp-loading>
</div>

<ng-container *ngIf="!loading">
    <div *ngIf="allItems.length === 0" class="no-content">
        <div class="no-content-text">This folder is empty.</div>
    </div>

    <div *ngIf="allItems.length > 0" class="items">
        <ng-container *ngFor="let item of allItems">
            <div *ngIf="isFolder(item)" class="folder" (click)="onFolderSelected(item)">
                <div class="icon"><span class="fas fa-folder-open"></span></div>
                <div class="text">{{item.Name}}</div>
            </div>
            <div *ngIf="!isFolder(item)" class="pdf" (click)="onPdfSelected(item)">
                <div class="icon"><span class="fa-2x far fa-file-pdf"></span></div>
                <div class="text">{{item.simpleName}}</div>
            </div>
        </ng-container>
    </div>
</ng-container>
